var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tab, Tabs } from '@mui/material';
import { createContext, useContext, useMemo } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
var TabsNavContext = createContext({
    qs: undefined,
});
/**
 * Tab that should be used inside {@link TabsNav}
 *
 * @param props
 * @returns
 */
export var LinkTab = function (props) {
    var context = useContext(TabsNavContext);
    return (_jsx(Tab, __assign({ component: Link, to: props.value + ((context && context.qs) || '') }, props, { onClick: function (e) { return e.preventDefault(); } }), void 0));
};
/**
 * Tabs container.
 * The value of this container will be the current location pathname, so each Tab element inside should
 * be associated to a pathname.
 *
 * When a Tab is selected, it will move the location to that page.
 *
 * Children should be {@link LinkTab} elements.
 *
 * @param props
 * @returns
 */
export var TabsNav = function (props) {
    var children = props.children, value = props.value, onChange = props.onChange;
    var history = useHistory();
    var location = useLocation();
    var qs = !props.noQueryString ? location.search : undefined;
    var contextValue = useMemo(function () { return ({ qs: qs }); }, [qs]);
    return (_jsx(TabsNavContext.Provider, __assign({ value: contextValue }, { children: _jsx(Tabs, __assign({ value: value || location.pathname || '/', onChange: function (e, value) {
                e.preventDefault();
                if (onChange) {
                    onChange(e, value);
                }
                else {
                    history.push({ pathname: value, search: qs });
                }
            }, variant: "scrollable", scrollButtons: "auto", allowScrollButtonsMobile: true }, { children: children }), void 0) }), void 0));
};
